<template>
  <header class="section header">
    <div class="columns">
      <div class="column is-10">
        <div class="page-title">
          <h1>{{ title }}</h1>
        </div>
      </div>
      <div class="column is-2 right-links">
        <inertia-link :href="this.route('logout')" method="post">
          <b-icon pack="fas" icon="sign-out-alt" size="is-small"></b-icon>
        </inertia-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    title: '',
  },
};
</script>
